const publicData = {
  PublicDataHeader: 'Lấy dữ liệu về tình trạng giao thông trong Tp. Hồ Chí Minh',
  InstructionHeader: 'Hãy thực hiện theo các bước sau để tiến hành lấy dữ liệu:',
  InstructionPosition: 'Chọn vị trí cụ thể trên bản đồ nơi muốn lấy dữ liệu. Hệ thống hiện tại cung cấp 3 phương thức để chọn vị trí, vui lòng chọn một:',
  SpeechChoose: 'Lấy vị trí từ đoạn ghi âm của tôi',
  RectangleChoose: 'Chọn theo hình chữ nhật',
  LineChoose: 'Chọn theo đường thẳng',
  CircleChoose: 'Chọn theo hình tròn',
  InstructionTitle: 'Hướng dẫn:',
  RectangleInstruction: 'Lần lượt click vào bản đồ để chọn 2 điểm đại diện cho đường đường chéo của hình chữ nhật, điều chỉnh vị trí 2 điểm này để thay đổi kích thước và vị trí của hình chữ nhật.',
  LineInstruction: 'Lần lượt click vào bản đồ để chọn 2 điểm đại diện cho điểm đầu và điểm cuối của đường thẳng, điều chỉnh vị trí 2 điểm này để thay đổi vị trí của đường thẳng.',
  CircleInstruction: 'Click vào bản đồ để chọn điểm làm tâm của hình tròn và điều chỉnh bán kính với thanh trượt trên bản đồ (đơn vị m, giá trị tối thiếủ là 100m, giá trị tối đa là 2000m)',
  DateTimePicker: 'Chọn thời gian muốn lấy dữ liệu:',
  GetDataButton: 'Lấy dữ liệu',
  PublicDataResultHeader: 'Kết quả:',
  PublicDataResult: `Vui lòng click vào nút "Lấy dữ liệu"`,
  LabelFromTitle: 'Từ',
  LabelToTitle: 'Đến',
  LabelDateSelect: 'Chọn ngày',
  LabelTimeSelect: 'Chọn giờ',
  ErrorNotChoosePosition: 'Vui lòng chọn địa điểm trên bản đồ!',
  ErrorNotChooseTime: 'Vui lòng kiểm tra lại thời gian!', 
  ErrorCoordsNotAvailable: 'Vị trí hiện tại không được hỗ trợ!',
  StartMarker: 'Điểm đầu',
  EndMarker: 'Điểm cuối',  
  YouAreHere: 'Bạn đang ở đây', 
  ErrorTimeFuture: 'Không được chọn thời gian trong tương lai!',  
  ErrorStartTimeMoreThanEndTime: 'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc!',
  ErrorPeriodTime: 'Khoảng thời gian phải dưới 6 giờ!',
  Distance: 'Khoảng cách',
  ChangeModeLabel: 'Thay đổi chế độ:',
  ViewTrafficStatusButton: 'Xem tình trạng giao thông',
  GetTrafficStatusButton: 'Lấy tình trạng giao thông',
  ViewTrafficStatusTutorial: `Với chế độ "XEM TÌNH TRẠNG GIAO THÔNG" bạn có thể xem tình trạng giao thông trên Bản đồ nhưng không thể lấy dữ liệu từ máy chủ.`,
  GetTrafficStatusTutorial: `Với chế độ "LẤY TÌNH TRẠNG GIAO THÔNG", bạn không thể thấy tình trạng giao thông trên Bản đồ nhưng bạn có thể lấy dữ liệu từ máy chủ. Làm theo các bước tiếp theo để lấy dữ liệu.`,
  Velocity: 'Vận tốc:',
  Source: 'Nguồn:',
  ErrorChangeMode: `Vui lòng đổi chế độ sang "LẤY TÌNH TRẠNG GIAO THÔNG"`,
}

export default publicData;